import { useContext, useEffect } from 'react';
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useParams,
} from 'react-router-dom';
import BackToShopButton from './components/BacktoShop/BackToShop';
import Header from './components/Header/Header';
import { LANGS } from './config/config';
import { AppContext } from './context/Contexte';
import Home from './screens/Home/Home';

const HomeScreen = () => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { changeLanguage } = useContext(AppContext);
  useEffect(() => {
    if (lang && LANGS.includes(lang)) {
      changeLanguage(lang);
    } else {
      navigate("/fr");
    }
  }, [lang, changeLanguage, navigate]);
  return (
    <div className="App">
      <div className="App-header">
        <BackToShopButton />
        <Header />
      </div>
      <div className="App-container">
        <Home />
      </div>
    </div>
  );
};

function App() {
  const { language } = useContext(AppContext);
  return (
    <Routes>
      <Route path="/:lang" element={<HomeScreen />} />
      <Route path="/" element={<Navigate replace to={`/${language}`} />} />
    </Routes>
  );
}

export default App;
